import Origins from './Origins';

export default Origins;
